import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getUsersPosts = async (
  user: string | number,
  limit: number,
  excludeId?: number,
) => {
  let req = supabase
    .from('posts')
    .select(`
      *,
      profile:user_profiles (id, username),
      assets:assets!posts_assets (
        *,
        category:categories(*)
      )`)
    .eq('creator_user_id', user)

  if (excludeId) {
    req = req.neq('id', excludeId)
  }
  if (limit) {
    req = req.limit(limit)
  }
  const { data, error } = await req;

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUsersPosts(
  user: number | string,
  limit: number = 25,
  excludeId?: number,
) {
  const queryKey = ['users-posts', user, limit, excludeId]
  return useQuery({
    queryKey,
    queryFn: () => getUsersPosts(user, limit, excludeId),
    enabled: Boolean(user),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
